import { getUuid } from '@/utils/api';
import i18n from '@/locales';

export const useFlow = () => {
	// 模块宽度计算
	const normalModuleWidth = 50;
	const specialModuleWidth = 100;

	function calculateModuleWidths(modules, filters) {
		const result = [];
		const normalQueue = [];

		modules.forEach(module => {
			const isSpecialModule = filters(module);
			if (isSpecialModule) {
				// 处理普通模块队列
				const queueWidths = processNormalQueue(normalQueue);
				result.push(...queueWidths);
				normalQueue.length = 0; // 清空队列
				result.push(specialModuleWidth);
			} else {
				// 普通模块，加入队列
				normalQueue.push(module);
			}
		});

		// 处理剩余的普通模块队列
		const remainingWidths = processNormalQueue(normalQueue);
		result.push(...remainingWidths);

		return result;
	}

	function processNormalQueue(queue) {
		if (queue.length === 0) {
			return [];
		}
		const widths = new Array(queue.length).fill(normalModuleWidth);
		if (queue.length % 2 === 1) {
			// 如果队列长度为奇数，最后一个模块独占宽度100
			widths[widths.length - 1] = 100;
		}
		return widths;
	}

	const composeFlowMenu = (originMenus = null) => {
		const menus = (originMenus || [])
			.map((data, index) => {
				const isSpecialModule = module => {
					if (data.moduleVOS.length === 1) return true;
					const specialModuleIds = ['investment_activity', 'quarterly_performance'];
					return specialModuleIds.includes(module.moduleId) || module.type === 2;
				};

				const displayModules = data.moduleVOS || [];
				const columns = calculateModuleWidths(displayModules, isSpecialModule);
				const updatedModules = displayModules.map((module, index) => ({
					...module,
					sort: module.sort || index + 1,
					column: columns[index] || 100
				}));

				data.moduleVOS = updatedModules.sort((a, b) => a.sort - b.sort);
				data.id = data.id || getUuid();
				data.sort = data.sort || index + 1;

				return data;
			})
			.filter(menu => menu.moduleVOS.length)
			.sort((a, b) => a.sort - b.sort);

		return menus;
	};

	const formatMobileFlowMenu = (originMenus = null) => {
		if (!originMenus) return [];
		return [{ id: 'home', name: i18n.t('enterprise.home') }, ...originMenus];
	};

	return {
		formatMobileFlowMenu,
		composeFlowMenu
	};
};
